import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  settingsPrivacyLegalInfoText: {
    lineHeight: Theme.px(48),
  },
  settingsPrivacyLegalInfoUrl: {
    lineHeight: Theme.px(62),
    marginTop: Theme.px(6),
  },
  settingsPrivacyLegalQR: {
    height: Theme.px(300),
    marginTop: Theme.px(250),
    width: Theme.px(300),
  },
  settingsPrivacyLegalWrapper: {
    alignItems: 'flex-start',
    maxWidth: Theme.px(1260),
  },
  wrapper: {
    paddingTop: Theme.px(311),
  },
});
